import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  return <section className="py-14 px-4 md:px-6 relative bg-[#0d1326] border-t border-slate-800/50" data-id="element-78">
      <div className="max-w-4xl mx-auto text-center" data-id="element-79">
        <FadeIn data-id="element-80">
          <div className="w-20 h-20 mx-auto bg-cyan-500/10 rounded-full flex items-center justify-center mb-8 border border-cyan-500/30 box-glow" data-id="element-81">
            <ShieldCheck className="w-10 h-10 text-cyan-400" data-id="element-82" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-83">
            Garantía de Satisfacción
          </h2>

          <p className="text-xl text-slate-300 mb-4 max-w-2xl mx-auto" data-id="element-84">
            Si en los primeros 7 días sientes que este protocolo no te ayuda
            como esperabas, te devuelvo tus $6.99 sin preguntas.
          </p>

          <p className="text-2xl font-bold text-cyan-400 mb-10" data-id="element-85">
            Mi intención es que recuperes tu energía, no que te quedes con una
            compra que no te sirvió.
          </p>

          <div className="pt-8 flex justify-center" data-id="element-86">
            <CTAButton text="SÍ, QUIERO EL PROTOCOLO POR $6.99" data-id="element-87" />
          </div>
        </FadeIn>
      </div>
    </section>;
}